import React from 'react'
import { withIcon } from '../../withIcon'

function MailRuIcon (props) {
  const {
    size = '24px',
    color = 'currentColor',
  } = props

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path d="M11.6887 6.73567C13.0628 6.73567 14.3577 7.37065 15.3066 8.36328V8.36622C15.3066 7.88954 15.6143 7.52896 16.0395 7.52896H16.1475C16.8185 7.52896 16.953 8.18856 16.953 8.3967L16.9558 15.8048C16.9091 16.2903 17.4367 16.5412 17.7298 16.2293C18.8688 15.008 20.2339 9.94458 17.0205 7.013C14.0236 4.27666 10.0013 4.72871 7.8627 6.26486C5.58971 7.90185 4.13682 11.5177 5.54808 14.916C7.08928 18.6209 11.4952 19.7261 14.1175 18.6238C15.445 18.0651 16.0569 19.9331 14.6772 20.5446C12.5977 21.4692 6.80242 21.3748 4.09575 16.489C2.26713 13.1887 2.36387 7.38296 7.21584 4.37516C10.9243 2.0727 15.8173 2.71061 18.767 5.92069C21.8494 9.2797 21.6711 15.5644 18.6618 18.0076C17.2989 19.1187 15.2751 18.0381 15.2897 16.4193L15.2745 15.8916C14.3256 16.8713 13.0628 17.4459 11.6887 17.4459C8.97022 17.4459 6.57686 14.9505 6.57686 12.1198C6.57686 9.25859 8.97022 6.73684 11.6887 6.73684V6.73567ZM15.108 11.9152C15.0051 9.84139 13.5286 8.59253 11.7444 8.59253H11.6769C9.62045 8.59253 8.47805 10.2811 8.47805 12.1954C8.47805 14.3419 9.85782 15.6975 11.6685 15.6975C13.6894 15.6975 15.0163 14.1561 15.1131 12.3326L15.108 11.9152Z" fill={color}/>
    </svg>
  )
}

export default withIcon(MailRuIcon)
